module.exports = __webpack_public_path__ + "media/application/images/img/overlays/03-e438ea2aabdb1087dc4f6fea5f6518e7.png";